export enum teamMemberStatus {
  active = "active",
  disabled = "disabled",
  pending = "pending",
}
